export default __webpack_public_path__ + "img/dTGwqAuc.e35760a9.svg";